import axios from 'axios';

/*
 * Axios calls required by the Product Purchased goal.
 *
 * All of these operations are against the `ProductPurchasedGoalController` in the BPM module.
 */

const BASE_URL = '/app/productPurchased';

export const loadOrderForms = async () => {
    const { data } = await axios.get(`${BASE_URL}/getOrderForms`);

    return data;
};

export const loadProductList = async () => {
    const { data } = await axios.get(`${BASE_URL}/getProductList`);

    return data;
};

export const loadProductCategories = async () => {
    const { data } = await axios.get(`${BASE_URL}/getProductCategories`);

    return data;
};

export const loadPaymentTypes = async () => {
    const { data } = await axios.get(`${BASE_URL}/getPaymentTypes`);

    return data;
};
